export default __webpack_public_path__ + "static/customer-cf616ac39b0cf17dc3ad2570b21750b8.png";